import { KeyRound, LogIn, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { errorText } from '../api/client';
import { API_BASE, ssoLoginUrl } from '../api/config';
import { Button, ErrorBox, Field, Input } from '../components/ui';

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">{children}</div>
    </div>
  );
}

export function LoginPage({ error, onLogin, sso }: { error: unknown; onLogin: (token: string) => void; sso: boolean }) {
  const [token, setToken] = useState('');
  return (
    <Shell>
      <div className="mb-5 flex items-center gap-3">
        <div className="rounded-md bg-brand-50 p-2 text-brand-600">
          <KeyRound className="size-5" />
        </div>
        <div>
          <h1 className="text-lg font-semibold">IT-Assets – Anmeldung</h1>
          <p className="text-sm text-slate-500">{sso ? 'Mit deinem Firmenkonto über Cloudflare Access.' : 'Im Betrieb meldest du dich automatisch über Cloudflare Access an.'}</p>
        </div>
      </div>
      {sso && (
        <div className="mb-5 space-y-2">
          <Button variant="primary" className="w-full" icon={<LogIn className="size-4" />} onClick={() => (window.location.href = ssoLoginUrl())}>
            Mit Firmenkonto anmelden
          </Button>
          <p className="text-center text-xs text-slate-400">API: {API_BASE}</p>
          <div className="flex items-center gap-2 pt-2 text-xs text-slate-400">
            <span className="h-px flex-1 bg-slate-200" /> oder mit API-Token <span className="h-px flex-1 bg-slate-200" />
          </div>
        </div>
      )}
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          if (token.trim()) onLogin(token.trim());
        }}
      >
        <Field label="Persönlicher API-Token" hint="Beginnt mit ita_ – erzeugt mit „npm run token:create“ im Backend oder unter „Mein Konto“.">
          {(p) => <Input {...p} type="password" autoComplete="off" value={token} onChange={(e) => setToken(e.target.value)} placeholder="ita_…" autoFocus />}
        </Field>
        {error ? <ErrorBox error={new Error(`Anmeldung fehlgeschlagen: ${errorText(error)}`)} /> : null}
        <Button type="submit" variant={sso ? 'secondary' : 'primary'} className="w-full" disabled={!token.trim()}>
          Anmelden
        </Button>
      </form>
    </Shell>
  );
}

export function NoAccountPage({ error, onLogout }: { error: unknown; onLogout: () => void }) {
  return (
    <Shell>
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 size-6 shrink-0 text-amber-500" />
        <div className="space-y-3">
          <h1 className="text-lg font-semibold">Kein Zugang</h1>
          <p className="text-sm text-slate-600">{errorText(error)} Bitte wende dich an einen Administrator.</p>
          <Button onClick={onLogout}>Abmelden</Button>
        </div>
      </div>
    </Shell>
  );
}
